import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import jwtDecode from 'jwt-decode';
import logout from '~/helpers/logout-helper';
import USE_MERCURE from '~/const/mercure';
export default {
  created: function created() {
    if (process.client && localStorage.getItem('MDM_ACCESS_TOKEN')) {
      var decoded = jwtDecode(localStorage.getItem('MDM_ACCESS_TOKEN'));
      if (this.invalidTokenForLegacyMarket(decoded) || this.invalidTokenForMercureMarket(decoded)) {
        logout(this.$store);
      }
    }
  },
  methods: {
    hasMercureAudience: function hasMercureAudience(token) {
      if (token && token.aud) {
        if (Array.isArray(token.aud)) return token.aud.includes('mercure');
        return token.aud === 'mercure';
      }
      return false;
    },
    isMercureOpenForMarket: function isMercureOpenForMarket() {
      return USE_MERCURE(this.locale.iso);
    },
    invalidTokenForLegacyMarket: function invalidTokenForLegacyMarket(token) {
      return !this.isMercureOpenForMarket() && this.hasMercureAudience(token);
    },
    invalidTokenForMercureMarket: function invalidTokenForMercureMarket(token) {
      return this.isMercureOpenForMarket() && !this.hasMercureAudience(token);
    }
  }
};